import { axiosGet, axiosPost } from '@/http/api'
/**
 * @description 我的积分
 */
export function getCount() {
  return new Promise((resolve, reject) => {
    axiosGet(`/api/points/my/current-points`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * @description 本周签到列表
 */
export function getWeekSign() {
  return new Promise((resolve, reject) => {
    axiosGet(`/api/points/sign-in`)
      .then((res) => {
        const arr = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        const { data } = res
        data.list.map((item, index) => {
          if (item.dateStatus == 0) {
            item.day = '今天'
          } else {
            item.day = arr[index]
          }
        })
        resolve(data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * @description 当日任务列表
 */
export function getTaskList() {
  return new Promise((resolve, reject) => {
    axiosGet(`/api/points/my/tasks`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

// /**
//  * @description 签到
//  */
// export function sign() {
//   return new Promise((resolve, reject) => {
//     axiosPost(`/api/`)
//       .then((res) => {
//         resolve(res)
//       })
//       .catch((error) => {
//         reject(error)
//       })
//   })
// }
/**
 * @description 更新积分
 */
export function updatePoints(eventCode, objId = '') {
  // eventCode
  // DEE5A7552  新用户礼包
  // 252EADE21  完成实名认证
  // 9D535ADE5  阅读资讯
  // 0F59F542A  首次打开APP
  // 51374FEDF  关注内容号
  // SC9FL2OV1  邀请注册送积分
  // 91F8B4DB4  打开应用
  // FF62652CE  分享资讯
  return new Promise((resolve, reject) => {
    axiosPost(`/api/points/credit`, { eventCode, objId })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * @description 获取列表
 */
export function getList(params) {
  const { page, pagesize } = params
  return new Promise((resolve, reject) => {
    axiosGet(`/api/points/my`, { page, size: pagesize })
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
